module.exports = __webpack_public_path__ + "static/media/ins17.eddebc85.jpg";